import { useMutation } from '@tanstack/react-query';
import {
  createOffboarding,
  invalidateOffboardings,
} from '../../services/offboardings';
import {
  CreateOffboardingPayload,
  Offboarding,
} from '../../types/offboardings';

function useCreateOffboarding(
  options: {
    onMutate?: () => void;
    onSuccess?: (offboarding: Offboarding) => void;
    onError?: (error: unknown) => void;
    onSettled?: () => void;
  } = {},
) {
  return useMutation({
    mutationFn: (payload: CreateOffboardingPayload) =>
      createOffboarding(payload),
    onMutate: options.onMutate,
    onSuccess: async result => {
      await invalidateOffboardings(result.businessId, result.id);
      options.onSuccess?.(result);
    },
    onError: options.onError,
    onSettled: options.onSettled,
  });
}

export default useCreateOffboarding;
